import {
  getTimeDelay,
  eventBus,
  ticketCheck,
  errorTicketUpdateHandler,
  ngsErrorTicketCheckHandler,
  capitalizeFirstLetter,
  busService,
  betslipUtility,
  getDisplayValueForFirstBallColorLuckyX,
} from '../../../utility';
import { ticketAPI } from '@/api';
import types from './mutationTypes';
import { isNil, cloneDeep } from 'lodash';

let lastShortcutPressed = '';

export default {
  setAdditionalGameConfig({ dispatch }) {
    dispatch('setBettingPreviewOdds');
  },
  updateSystemInputValidations({ state, getters, dispatch }) {
    const { localGameConfig } = state;

    const systemBet = localGameConfig.additionalBettingInputs.find((input) => input.betDisplayName === 'system');
    let currentMaximumSystem = Object.values(getters.betInputData.value).length;

    // If random system bet is selected, take input field value instead of length
    if (state.selectedBet.clientId === 3) {
      currentMaximumSystem = Object.values(getters.betInputData.value)[0] ?? 1;
    }

    // If color system bet is selected
    if (state.selectedBet.clientId === 5) {
      currentMaximumSystem = 10;
    }

    // Reset system value if current system is higher than allowed (e.g. 8/8)
    if (Number(getters.betInputData.system) >= currentMaximumSystem) dispatch('updateSystem', null);

    // Update system range validation
    const rangeValidation = systemBet.validations.find((validation) => validation.type === 'range');
    rangeValidation.max = currentMaximumSystem < 2 ? 0 : currentMaximumSystem - 1; // Allow input if enough spots for system are played;
    rangeValidation.min = currentMaximumSystem > 1 ? 1 : 0; // Forbid input if not enough spots are played;

    // Update system length validation
    systemBet.validations.find((validation) => validation.type === 'length').max = currentMaximumSystem > 9 ? 2 : 1;
  },
  async handleBusMessages({ dispatch, state, getters, commit, rootState, rootGetters }, eventData) {
    const { eventName, eventId } = eventData;
    const eventTime = eventData.time;
    const sentTime = eventData.sentTime || Date.now();
    let countdownTime;
    const eventType = eventData.type;

    switch (eventName) {
      case 'SetState':
        await dispatch(
          'setBusLoaded',
          {
            game: state.name,
            busLoaded: true,
          },
          { root: true },
        );
        dispatch('setEventDisplayId', eventId);
        dispatch('setEventName', eventType);
        switch (eventType) {
          case 'StartCountdown':
          case 'countdown':
          case 'bettingDisabled':
          case 'StopBetting': {
            const delay = eventData.delay;
            countdownTime = getTimeDelay(eventTime, sentTime, delay);
            dispatch('setEventTime', countdownTime);
            dispatch('setCountdownInterval');
            if (eventType === 'bettingDisabled' || eventType === 'StopBetting') {
              dispatch('setBettingDisabled', true);
            }
            break;
          }
          case 'results':
          case 'SetResults': {
            break;
          }
          case 'ball':
          case 'DrawResult': {
            break;
          }
          case 'new':
          case 'StartEvent': {
            dispatch('setBettingDisabled', false);
            break;
          }
        }
        break;
      case 'new':
      case 'StartEvent': {
        dispatch('setBettingDisabled', false);
        dispatch('setEventName', eventName);
        dispatch('setEventName', eventName);
        dispatch('updateBetEvent', { game: state.name, roundNumber: +getters.eventDisplayId + 1 }, { root: true });
        break;
      }
      case 'results':
      case 'SetResults': {
        dispatch('setEventName', eventName);
        break;
      }
      case 'countdown':
      case 'StartCountdown': {
        dispatch('setEventName', eventName);
        countdownTime = eventData.delay;
        dispatch('setEventDisplayId', eventId);
        dispatch('setEventTime', countdownTime);
        dispatch('setCountdownInterval');
        if (rootGetters.fullShopMode && rootState.currentActiveGame === 'luckyx') {
          dispatch('getLastTickets', {}, { root: true });
        }
        break;
      }
      case 'ball':
      case 'DrawResult': {
        break;
      }
      case 'bettingDisabled':
      case 'StopBetting': {
        dispatch('setEventName', eventName);
        dispatch('setBettingDisabled', true);
        break;
      }
      case 'TicketUpdate': {
        if (!eventData.code && !eventData.httpCode) {
          ticketCheck.stopTicketChecker(eventData);
          // TODO: Refactor for serbian taxId which will be on ticket level
          // TODO: IMPLMENENT BET GUIDS
          // if (data.ticket.bets[0].additionalDetails?.taxId) await dispatch('mapBetGuids', data);
          // dispatch('betslip/disablePayinButton', false, { root: true });

          // Send message over GGateway event 'Tickets.Update' to update state of ticket on platform
          const ticketData = {
            action: capitalizeFirstLetter(eventData.action), // available values: Add, Cancel, Payout
            ticket: eventData,
          };
          eventBus.$emit('ticketUpdate', ticketData);
          // CHECK IF THE TICKET SHOULD BE PRINTED
          if (
            rootState.ticketChecksInProgress.some(
              (ticket) => ticket.id === eventData.id || ticket.requestUuid === eventData.requestUuid,
            )
          ) {
            commit('REMOVE_TICKET_CHECK_IN_PROGRESS', eventData.id, { root: true });
          } else if (rootState.printedTicketsByTicketCheck.some((ticket) => ticket.id === eventData.id)) {
            commit('REMOVE_PRINTED_TICKET_BY_TICKET_CHECK', eventData.id, { root: true });
          } else {
            eventBus.$emit('printTemplate', ticketData);
          }
        } else {
          errorTicketUpdateHandler(eventData);
          ticketCheck.stopTicketChecker({ requestId: eventData.requestUuid });
        }
        break;
      }
      case 'game.deactivated':
        dispatch('setConnectionStatus', false);
        break;
      case 'game.activated':
        dispatch('setConnectionStatus', true);
        break;
    }
  },
  async handleGameShortcuts({ state, dispatch, getters, rootGetters }, payload) {
    const { bettingInputs, additionalBettingInputs } = state.localGameConfig;
    const { defaultShortcut, quickBetslipModeAllowed, quickBetslipModeShortcut } = getters;
    const { ticketPinModalActive, fullShopMode } = rootGetters;
    // Disable shortcuts if ticket pin modal is active, this is done not to trigger a shortcut while inputing in the ticket pin.
    if (fullShopMode && ticketPinModalActive) return;
    // TOGGLE QUICK BETSLIP MODE
    if (
      quickBetslipModeAllowed &&
      !payload.ctrlKey &&
      payload.key.toLowerCase() === quickBetslipModeShortcut.shortcut.toLowerCase()
    ) {
      dispatch('toggleQuickBetslipMode');
    }
    // FIND IF A THE GAME HAS A BET WITH THE SHORTCUT THAT IS CALLED
    const newBet = bettingInputs.filter(
      (bettingInput) =>
        bettingInput.shortcut === String(payload.key.trim()).toLowerCase() && !payload.ctrlKey && bettingInput.enabled,
    );
    if (newBet.length) {
      const bet = newBet[0];
      // Client ids of bets that support keeping valid input on change
      const supportedClientIds = [0, 1];

      const resetRequired =
        !getters.keepValidInputOnBetChange ||
        !supportedClientIds.includes(getters.selectedBet.clientId) ||
        !supportedClientIds.includes(bet.clientId) ||
        (lastShortcutPressed === defaultShortcut.shortcut && payload.key === defaultShortcut.shortcut);

      // To reset when switching from bet which does not support keeping input
      if (resetRequired) {
        await dispatch('resetBetInputValue');
      }

      await dispatch('setSelectedBet', bet);
      await dispatch('clearAdditionalInputs');

      const systemBetActive = newBet[0].additionalInputs?.includes('system');
      const isRandomBetActive = newBet[0].additionalInputs?.includes('random');

      if (!rootGetters.editBetModeActive && !systemBetActive && !isRandomBetActive) {
        eventBus.$emit('focusFirstBettingInput');
      }

      if (systemBetActive && !isRandomBetActive) {
        const systemInput = additionalBettingInputs.filter((bettingInput) => bettingInput.clientId === 'system')[0];
        await dispatch('setAdditionalInput', systemInput);
      }
      if (isRandomBetActive && !systemBetActive) {
        const randomInput = additionalBettingInputs.filter((bettingInput) => bettingInput.clientId === 'random')[0];
        await dispatch('setAdditionalInput', randomInput);
      }
    }

    // FIND IF THERE ARE ANY ADDITIONAL INPUTS THAT SHOULD BE SHOWN ON SHORTCUT ( Future, system )
    const additionalInput = additionalBettingInputs.filter(
      (bettingInput) =>
        bettingInput.shortcut === String(payload.key.trim()).toLowerCase() && bettingInput.enabled && !payload.ctrlKey,
    );

    const isAdditionalInputAllowed =
      additionalInput[0] && getters.selectedBet.additionalInputs?.includes(additionalInput[0].clientId);

    if (additionalInput.length && isAdditionalInputAllowed && !getters.isBettingDisabled) {
      dispatch('setAdditionalInput', additionalInput[0]);
    }
    // Check if there are any outcome shortcuts
    if (getters.selectedBet.outcomeShortcuts) {
      await dispatch('handleOutcomeShortcuts', { data: payload });
    }

    lastShortcutPressed = payload.key.toLowerCase();
  },
  async handleOutcomeShortcuts({ getters, dispatch }, payload) {
    const { key } = payload.data;
    const { outcomeShortcuts } = getters.selectedBet;
    const outcomeShortcut = outcomeShortcuts.filter((shortcuts) => shortcuts.shortcut === key)[0];
    const { quickBetslipModeActive, isBettingDisabled, colorBetSelectionOnlyAction } = getters;
    // Outcome shortcuts shouldn't be activated on any additional input fields
    const shortcutClasses = ['input-field', 'shortcut', 'games-client-shop'];
    const activeElementClasses = Array.from(document.activeElement.classList);
    const activateShortcut =
      shortcutClasses.some((item) => activeElementClasses.includes(item)) && !activeElementClasses.includes('future');
    if (!outcomeShortcut || isBettingDisabled || !activateShortcut) return;
    // activate these shortcuts only if future is not focused
    if (quickBetslipModeActive) {
      dispatch('setSingleBetInputValue', { inputId: 1, inputValue: outcomeShortcut.shortcut });
    } else {
      return;
    }

    setTimeout(async () => {
      if (outcomeShortcut?.action?.name === 'color' && colorBetSelectionOnlyAction) return;
      await dispatch('addToBetslip', null, { root: true });
      eventBus.$emit('focusTotalPayment');
    }, 0);
  },
  setSingleBetInputValue({ commit, dispatch }, { inputId, inputValue }) {
    if (inputId === 'future' || inputId === 'system' || inputId === 'random') return;
    commit(types.SET_SINGLE_BET_INPUT_VALUE, { inputId, inputValue });
    dispatch('updateSystemInputValidations');
  },
  updateFuture({ commit }, value) {
    commit(types.UPDATE_FUTURE, value);
  },
  setBettingPreviewOdds({ state }) {
    const bets = Object.values(state.config.bets);
    const { bettingInputs } = state.localGameConfig;

    for (let i = 0; i < bets.length; i++) {
      const bet = bets[i];

      const bettingInput = bettingInputs.find((input) => input.betId === bet.id);

      if (!bettingInput) continue;

      let { betDisplayName, betType } = bettingInput;
      let outcomes = [];
      let betLimit;

      switch (bet.id) {
        case 21:
        case 24:
        case 25:
          if (bet.limit) betLimit = bet.limit;
          outcomes = [
            { outcome: bet.outcomes[0], odd: bet.odds, shortcut: '1' },
            { outcome: bet.outcomes[1], odd: bet.odds, shortcut: '2' },
          ];
          break;
        default:
          continue;
      }

      bettingInput.bettingPreview = {
        betDisplayName,
        betType,
        outcomes,
        betLimit,
      };
    }
  },
  async handleTicketsCheckEvent({ dispatch, getters, rootState }, payload) {
    if (payload.data?.ticket?.bets) {
      // MAP BOTH TICKETS
      dispatch('showTicketPreview', { ticket: payload.data?.ticket, ticketVersion: '1' }, { root: true });
      busService.sendMessage('UI.Hide', { name: ['All'] });
    } else {
      // 'slave' (new) strategy for ticket check
      const ticketId = payload.data?.ticket?.id;
      const { ticketType } = getters.localGameConfig;
      const ticketCheckTicket = await ticketAPI
        .checkTicketBarcode(ticketId, ticketType, getters.name)
        .then((response) => response)
        .catch((error) => {
          ngsErrorTicketCheckHandler(error);
        });
      // add ticket pin if it exist
      if (isNil(ticketCheckTicket)) return;
      ticketCheckTicket.ticketPin = payload.data?.ticket.ticketPin ? payload.data?.ticket.ticketPin : null;
      if (
        (ticketCheckTicket.status.value.toLowerCase() === 'won' ||
          ticketCheckTicket.superBonus?.status?.value.toLowerCase() === 'won') &&
        rootState.autoPayout
      ) {
        const action = 'Tickets.Payout';
        const ticketData = {
          action,
          data: {
            ticket: ticketCheckTicket,
          },
        };
        busService.sendMessageAsync(ticketData.action, ticketData.data);
      } else {
        dispatch('showTicketPreview', { ticket: ticketCheckTicket, ticketVersion: '1' }, { root: true });
        busService.sendMessage('UI.Hide', { name: ['All'] });
      }
    }
    // Checked the ticket and forwards ticket data to product ticket preview (popup)
  },
  async rebetTicket({ dispatch }, bets) {
    const filteredBets = betslipUtility.groupFutureBets(cloneDeep(bets));

    dispatch('clearBetslipTicket');
    await dispatch('clearBetslip', null, { root: true });

    const newBets = [];

    filteredBets.forEach((bet) => {
      const betData = { value: {} };
      const { type } = bet;
      betData.betId = type;

      switch (true) {
        case type >= 0 && type <= 19: {
          betData.value = Object.fromEntries(bet.value.map((value, index) => [String(index + 1), String(value)]));
          betData.betId = 0;

          if (type >= 11 && type <= 19) {
            betData.system = type - 10;
          }
          break;
        }

        case [21, 24, 25].includes(type): {
          betData.value[1] = bet.outcome.value ? '2' : '1';
          break;
        }

        case type === 23: {
          betData.value[1] = String(bet.value);
          break;
        }

        case type === 22: {
          betData.value = getDisplayValueForFirstBallColorLuckyX(bet.value);
          break;
        }
      }

      betData.future = bet.numEvents || 1;
      const newBet = betslipUtility.createLuckyXBet(betData);

      newBet[0].stake = Number((bet.amount + bet.tax).toFixed(2));
      newBets.push(...newBet);
    });

    for (let i = 0; i < newBets.length; i++) {
      await dispatch('gamesBetslip/addBet', newBets[i], { root: true });
    }
  },
};
